module.exports = __webpack_public_path__ + "static/media/fbLogo.7d3351e4.svg";